import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { db, storage } from "../firebase";

function useMarketingManager({
  banners,
  tipoMkt,
  tituloMkt,
  subtituloMkt,
  turnoMkt,
  promoIdMkt,
  productoIdMkt,
  mostrarBotonMkt,
  textoBotonMkt,
  infoAdicionalMkt,
  archivoMarketing,
  modoEdicionMkt,
  mktEditId,
  mktEditColeccion,
  setMensaje,
  setCargandoMkt,
  setArchivoMarketing,
  setTituloMkt,
  setSubtituloMkt,
  setTurnoMkt,
  setPromoIdMkt,
  setProductoIdMkt,
  setMostrarBotonMkt,
  setTextoBotonMkt,
  setInfoAdicionalMkt,
  setModoEdicionMkt,
  setMktEditId,
  setMktEditColeccion,
  setTipoMkt,
  setPestañaActiva,
  cargarProductos,
}) {
  const resetFormulario = () => {
    setArchivoMarketing(null);
    setTituloMkt("");
    setSubtituloMkt("");
    if (setTurnoMkt) setTurnoMkt("auto");
    setPromoIdMkt("");
    if (setProductoIdMkt) setProductoIdMkt("");
    if (setMostrarBotonMkt) setMostrarBotonMkt(true);
    if (setTextoBotonMkt) setTextoBotonMkt("TOCA PARA PEDIR →");
    if (setInfoAdicionalMkt) setInfoAdicionalMkt("");
    setModoEdicionMkt(false);
    setMktEditId(null);
    setMktEditColeccion(null);

    const inputMkt = document.getElementById("input-marketing");
    if (inputMkt) inputMkt.value = "";
  };

  const handleMarketingSubmit = async (e) => {
    e.preventDefault();

    if (!modoEdicionMkt && !archivoMarketing) {
      setMensaje("⚠️ Selecciona un archivo.");
      return;
    }

    if (tipoMkt === "banner" && banners.length >= 5 && !modoEdicionMkt) {
      setMensaje("⚠️ Máximo 5 banners.");
      return;
    }

    setCargandoMkt(true);
    setMensaje("");

    try {
      let urlMedia = null;
      let esVideo = false;

      if (archivoMarketing) {
        const nombreUnico = `${Date.now()}_${archivoMarketing.name}`;
        const storageRef = ref(storage, `marketing/${nombreUnico}`);
        await uploadBytes(storageRef, archivoMarketing);
        urlMedia = await getDownloadURL(storageRef);
        esVideo = archivoMarketing.type.includes("video");
      }

      if (!modoEdicionMkt) {
        if (tipoMkt === "banner") {
          await addDoc(collection(db, "marketing"), {
            url: urlMedia,
            titulo: tituloMkt,
            subtitulo: subtituloMkt,
            fechaCreacion: new Date().toISOString(),
          });
          setMensaje("✅ Banner publicado.");
        } else {
          await addDoc(collection(db, "especiales"), {
            url: urlMedia,
            titulo: tituloMkt,
            descripcion: subtituloMkt,
            turno: turnoMkt || "auto",
            tipo: esVideo ? "video" : "imagen",
            fechaCreacion: new Date().toISOString(),
            promoId: promoIdMkt || null,
            productoId: productoIdMkt || null,
            infoAdicional: (infoAdicionalMkt || "").trim(),
            mostrarBoton: mostrarBotonMkt !== false,
            textoBoton: (textoBotonMkt || "TOCA PARA PEDIR →").trim(),
          });
          setMensaje("✅ Especial publicado.");
        }
      } else {
        if (!mktEditId || !mktEditColeccion) {
          setMensaje("❌ Error edición.");
          setCargandoMkt(false);
          return;
        }

        if (mktEditColeccion === "marketing") {
          const payload = {
            titulo: tituloMkt,
            subtitulo: subtituloMkt,
          };

          if (urlMedia) payload.url = urlMedia;

          await updateDoc(doc(db, "marketing", mktEditId), payload);
          setMensaje("✅ Banner actualizado.");
        } else {
          const payload = {
            titulo: tituloMkt,
            descripcion: subtituloMkt,
            turno: turnoMkt || "auto",
            promoId: promoIdMkt || null,
            productoId: productoIdMkt || null,
            infoAdicional: (infoAdicionalMkt || "").trim(),
            mostrarBoton: mostrarBotonMkt !== false,
            textoBoton: (textoBotonMkt || "TOCA PARA PEDIR →").trim(),
          };

          if (urlMedia) {
            payload.url = urlMedia;
            payload.tipo = esVideo ? "video" : "imagen";
          }

          await updateDoc(doc(db, "especiales", mktEditId), payload);
          setMensaje("✅ Especial actualizado.");
        }
      }

      resetFormulario();
      cargarProductos();
    } catch (error) {
      console.error(error);
      setMensaje("❌ Error marketing.");
    } finally {
      setCargandoMkt(false);
    }
  };

  const handleEliminarMarketing = async (id, coleccionNombre) => {
    try {
      await deleteDoc(doc(db, coleccionNombre, id));
      setMensaje("⚙️ Eliminado.");
      cargarProductos();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditarMarketing = (item, coleccionNombre) => {
    setModoEdicionMkt(true);
    setMktEditId(item.id);
    setMktEditColeccion(coleccionNombre);

    if (coleccionNombre === "marketing") {
      setTipoMkt("banner");
      setTituloMkt(item.titulo || "");
      setSubtituloMkt(item.subtitulo || "");
    } else {
      setTipoMkt("especial");
      setTituloMkt(item.titulo || "");
      setSubtituloMkt(item.descripcion || "");
      setPromoIdMkt(item.promoId || "");
      if (setTurnoMkt) setTurnoMkt(item.turno || "auto");
      if (setProductoIdMkt) setProductoIdMkt(item.productoId || "");
      if (setMostrarBotonMkt) setMostrarBotonMkt(item.mostrarBoton !== false);
      if (setTextoBotonMkt)
        setTextoBotonMkt(item.textoBoton || "TOCA PARA PEDIR →");
      if (setInfoAdicionalMkt) setInfoAdicionalMkt(item.infoAdicional || "");
    }

    setArchivoMarketing(null);

    const inputMkt = document.getElementById("input-marketing");
    if (inputMkt) inputMkt.value = "";

    setPestañaActiva("marketing");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return {
    handleMarketingSubmit,
    handleEliminarMarketing,
    handleEditarMarketing,
    resetFormulario,
  };
}

export default useMarketingManager;
